const routes = [
    {
        name: 'PcHome',
        path: '/PcHome',
        component: () => import('@/view/PcHome')
    },
    {
        name: 'PmdHome',
        path: '/PmdHome',
        component: () => import('@/view/PmdHome')
    },

];

export default routes
